import { HTTPError } from 'ky';

interface ApiErrorBody {
  error?: string;
}

// bop-api's stockResponses error shape is `{ error: string }` — promote it to the
// error message so UI surfaces say something useful.
export class ApiError extends HTTPError {
  constructor(error: HTTPError, body: ApiErrorBody | null) {
    super(error.response, error.request, error.options);
    this.name = 'ApiError';
    if (body?.error) this.message = body.error;
  }
}

export const parseApiErrorHook = async (error: HTTPError): Promise<HTTPError> => {
  let body: ApiErrorBody | null = null;
  try {
    body = (await error.response.clone().json()) as ApiErrorBody;
  } catch {
    // non-JSON error body — keep ky's default message
  }
  return new ApiError(error, body);
};

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  return 'Unexpected error';
};

export const HTTP_BAD_REQUEST = 400;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_CONFLICT = 409;
export const HTTP_UNPROCESSABLE_ENTITY = 422;
export const HTTP_INTERNAL_SERVER_ERROR = 500;

// Shared status predicate — service modules previously each re-derived this two-liner.
// Compound checks compose: isHttpStatus(error, HTTP_BAD_REQUEST) && error.message === '…'.
export const isHttpStatus = (error: unknown, status: number): error is HTTPError => error instanceof HTTPError && error.response.status === status;

export const isNotFoundError = (error: unknown): error is HTTPError => isHttpStatus(error, HTTP_NOT_FOUND);

export const isForbiddenError = (error: unknown): error is HTTPError => isHttpStatus(error, HTTP_FORBIDDEN);
